<html>

    <head>
        <style>
            label { color: white}
        </style>
    </head>
    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    <body>
        
        <div class="ExitImage ExitButton">
            <dx-button  
                #btnclose
                id="btnclose"
                
                stylingMode="outlined"
                type="normal"

                icon="fas fa-times"

                height="20px"
                width="20px"

                (onClick)="closedialog( $event )"
            >
    
            </dx-button>
        </div>
        <!--xxxxxxxxxxxxxx REGISTER = 10 xxxxxxxxxxxXXXXXxxxxxxxxxxxxxxxx-->
        <div *ngIf="logintype === 10"  class="inputleftmargin20">

            <dx-validation-group>
                 <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <div id="elementoneline">

                    <dx-text-box
                        #selevent
                        id="eventname"
                        [(value)]="eventname"

                        label="Event Name"
                        [inputAttr]="{ autocomplete: 'chrome-off' }"
                        [showClearButton]="true" 
                    
                        width="405px"
                        height="30px"

                        [disabled]="inputdisable"

                        placeholder="Enter Event Name"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Event Name is required"></dxi-validation-rule>
                        </dx-validator> 

                    </dx-text-box>

                </div>
                 <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <br>
                <br>
                <br>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <div id="elementoneline">

                        <dx-text-box
                            #selemail
                            id="email"
                            [(value)]="email"

                            label="Email"
                            [inputAttr]="{ autocomplete: 'chrome-off' }"
                            [showClearButton]="true" 
                        
                            width="405px"
                            height="30px"

                            [disabled]="inputdisable"

                            placeholder="Enter Email"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                            
                                <dxi-validation-rule 
                                    type="pattern"
                                    [pattern]="emailPattern"
                                    message="Invalid Email Name">
                                </dxi-validation-rule> 

                            </dx-validator> 

                        </dx-text-box>
                </div>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <br>
                <br>
                <br>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <div id="elementoneline">

                    <dx-text-box
                        id="password"
                        [(value)]="password"

                        label="Password"
                        
                        [inputAttr]="{ autocomplete: 'chrome-off' }"

                        [(mode)]="passwordMode"
                    
                        width="200px"
                        height="30px"

                        [disabled]="inputdisable"

                        placeholder="Enter Password"
                    >

                        <dxi-button
                            name="today"
                            location="after"
                            [options]="passwordButton"
                        >
                        </dxi-button>

                        <dx-validator>
                            <dxi-validation-rule 
                                type="required" 
                                message="Password is required">
                            </dxi-validation-rule>
                    
                            <dxi-validation-rule 
                                type="stringLength" 
                                [min]="8" message="Password must have at least 8 characters">
                            </dxi-validation-rule>
                    
                        </dx-validator> 
                    
                    </dx-text-box>

                    &nbsp;&nbsp;

                    <dx-text-box
                        id="passwordconfirm"
                        [(value)]="passwordconfirm"

                        label="Password Confirm"
                        [inputAttr]="{ autocomplete: 'chrome-off' }"
                    
                        [(mode)]="passwordModeconfirm"
                    
                        width="200px"
                        height="30px"

                        placeholder="Enter Confirm Password"
                    >
                    
                        <dxi-button
                            name="today"
                            location="after"
                            [options]="passwordButtonConfirm"
                        >
                        </dxi-button>

                        <dx-validator>

                            <dxi-validation-rule 
                                type="required" 
                                message="Confirm Password is required">
                            </dxi-validation-rule>
                        
                            <dxi-validation-rule type="compare" [comparisonTarget]="passwordComparison"
                                message="Password and Confirm Password do not match">
                            </dxi-validation-rule>

                            <dxi-validation-rule 
                                type="stringLength" 
                                [min]="8" message="Password must have at least 8 characters">
                            </dxi-validation-rule>
                        
                        </dx-validator> 
                
                    </dx-text-box>

                </div>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <br>
                <br>
                <br>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <div id="elementoneline">

                    <dx-button  
                        #btnpayment
                        id="btnpayment"
                        text="Register Event"
        
                        stylingMode="outlined"
                        type="normal"
                
                        height="40px"
                        width="405px"

                        [disabled]="inputdisable"

                        (onClick)="paymentstripe( $event, 1, logintype )"
                    >

                    </dx-button>

                </div>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <br>
                <br>
                <br>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <div id="elementoneline">

                    <dx-button  
                        #btnconfirm
                        id="btnconfirm"
                        text="Confirm"
            
                        stylingMode="outlined"
                        type="normal"
                    
                        height="40px"
                        width="200px"   
                        
                        [disabled]="btndisable"
                        [visible]="btnconfirmvisible"

                        [elementAttr]="{ class: 'marginleft0' }"
        
                        (onClick)="loginstatus( $event, 1, logintype )"
                    >
            
                    </dx-button>
        
                    <dx-button  
                        #btncancel
                        id="btncancel"
                        text ="Cancel"
        
                        stylingMode="outlined"
                        type="normal"
                    
                        height="40px"
                        width="200px"
        
                        (onClick)="loginstatus( $event, 0, logintype)"
                    >
        
                    </dx-button>

                </div>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            </dx-validation-group>

        </div>
        <!--xxxxxxxxxxxxxx LOGIN = 20 xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <div *ngIf="logintype === 20">

            <dx-validation-group>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <div id="elementoneline">

                    <div class="inputleftmargin20">

                        <dx-text-box
                            #selemail
                            id="email"
                            [(value)]="email"

                            label="Email"
                            [inputAttr]="{ autocomplete: 'chrome-off' }"
                            [showClearButton]="true" 
                        
                            width="415px"
                            height="30px"

                            placeholder="Enter Email"
                        >
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                            
                                <dxi-validation-rule 
                                    type="pattern"
                                    [pattern]="emailPattern"
                                    message="Invalid Email Name">
                                </dxi-validation-rule> 

                            </dx-validator> 

                        </dx-text-box>

                    </div>

                </div>
                 <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <br>
                <br>
                <br>
                <br>
                 <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <div id="elementoneline">
                    
                    <dx-text-box
                        id="password"
                        [(value)]="password"

                        [(label)]="passwordlabel"
                        
                        [inputAttr]="{ autocomplete: 'chrome-off' }"

                        [(mode)]="passwordMode"
                    
                        width="200px"
                        height="30px"

                        [elementAttr]="{ class: 'marginleft10' }"

                        placeholder="Enter Password"
                    >

                        <dxi-button
                            name="today"
                            location="after"
                            [options]="passwordButton"
                        >
                        </dxi-button>

                        <dx-validator>
                            <dxi-validation-rule 
                                type="required" 
                                message="Password is required">
                            </dxi-validation-rule>
                    
                            <dxi-validation-rule 
                                type="stringLength" 
                                [min]="8" message="Password must have at least 8 characters">
                            </dxi-validation-rule>
                    
                        </dx-validator> 
                    
                    </dx-text-box>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    &nbsp;&nbsp;
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dx-check-box 
                        id="checkBoxContainer"
                        text="Reset Password"
                        [(value)]="checkBoxValue"
                        [visible]="checkBoxVisible"
                    >

                    </dx-check-box>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    &nbsp;&nbsp;
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <div *ngIf="resetPasswordconfirm === true">
                    <dx-text-box
                            id="passwordconfirm"
                            [(value)]="passwordconfirm"

                            label="Password Confirm"
                            [inputAttr]="{ autocomplete: 'chrome-off' }"
                        
                            [(mode)]="passwordModeconfirm"
                        
                            width="200px"
                            height="30px"

                            placeholder="Enter Confirm Password"
                        >
                        
                            <dxi-button
                                name="today"
                                location="after"
                                [options]="passwordButtonConfirm"
                            >
                            </dxi-button>

                            <dx-validator>

                                <dxi-validation-rule 
                                    type="required" 
                                    message="Confirm Password is required">
                                </dxi-validation-rule>
                            
                                <dxi-validation-rule type="compare" [comparisonTarget]="passwordComparison"
                                    message="Password and Confirm Password do not match">
                                </dxi-validation-rule>

                                <dxi-validation-rule 
                                    type="stringLength" 
                                    [min]="8" message="Password must have at least 8 characters">
                                </dxi-validation-rule>
                            
                            </dx-validator> 
                            
                        </dx-text-box>

                    </div>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                </div>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <br>
                <br>
                <br>
                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                <div id="elementoneline">

                    <dx-button  
                        #btnconfirm
                        id="btnconfirm"
                        text="Confirm"
            
                        stylingMode="outlined"
                        type="normal"
                    
                        height="40px"
                        width="200px"

                        [elementAttr]="{ class: 'marginleft10' }"
        
                        (onClick)="loginstatus( $event, 1, logintype )"
                    >
            
                    </dx-button>
        
                    &nbsp;&nbsp;
        
                    <dx-button  
                        #btncancel
                        id="btncancel"
                        text ="Cancel"
        
                        stylingMode="outlined"
                        type="normal"
                    
                        height="40px"
                        width="200px"
        
                        (onClick)="loginstatus( $event, 0, logintype)"
                    >
        
                    </dx-button>

                </div>
                 <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            </dx-validation-group>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        </div>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-toast
            [(message)]       =   "toastFileMessage"
            [(visible)]       =   "toastVisible"
            [type]            =   "toasttypeerror"
            [displayTime]     =   "toastdisplaytime"  
            [width]           =   "toastwidth" 
        >
                        
            <dxo-position>

                <dxo-at 
                    x="left" 
                    y="top">
                </dxo-at>

                <dxo-offset
                    [x]="150" 
                    [y]="20"
                >
                </dxo-offset>
                
            </dxo-position>

        </dx-toast>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>
    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
</html>
